// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsUsersResult = objectOf({
  daily_user_profiles: arrayOf(arrayOf(number)),
});
